import { render, staticRenderFns } from "./MarkDetail.vue?vue&type=template&id=f8677804&scoped=true"
import script from "./MarkDetail.vue?vue&type=script&lang=js"
export * from "./MarkDetail.vue?vue&type=script&lang=js"
import style0 from "./MarkDetail.vue?vue&type=style&index=0&id=f8677804&prod&lang=scss&scoped=true"
import style1 from "./MarkDetail.vue?vue&type=style&index=1&id=f8677804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8677804",
  null
  
)

export default component.exports